export enum CustomerType {
  Service = 'SERVICE',
  Saas = 'SAAS',
  Growth = 'GROWTH',
}

/** Customer types that ship with their own (specific) fleets. */
export const SPECIFIC_FLEET_CUSTOMER_TYPES: CustomerType[] = [CustomerType.Saas, CustomerType.Growth];
